import React, { useEffect } from "react";
import moment from "moment";
import "./motorDetails.css";
import { FaSpinner } from "react-icons/fa";

const granularities = {
  minute: "Minute",
  hour: "Heure",
  day: "Jour",
};

export default function DateForm({ donnee, setDonnee, handleSubmit, loading }) {

  // Init valeurs par défaut
  useEffect(() => {
    setDonnee({
      ...donnee,
      debut: moment().format("YYYY-MM-DD"),
      fin: moment().format("YYYY-MM-DD"),
      granularity: "minute",
    });
  }, []);

  // Calcul granularité
  const diffDays = moment(donnee.fin).diff(moment(donnee.debut), "days");

  let availableGranularities = ["minute"];
  if (diffDays >= 2 && diffDays <= 30) {
    availableGranularities = ["hour"];
  } else if (diffDays >= 31) {
    availableGranularities = ["day"];
  }

  // Auto-correction granularité
  useEffect(() => {
    if (!availableGranularities.includes(donnee.granularity)) {
      setDonnee({
        ...donnee,
        granularity: availableGranularities[0],
      });
    }
  }, [donnee.debut, donnee.fin]);

  const handleGranularityChange = (event) => {
    setDonnee({
      ...donnee,
      granularity: event.target.value,
    });
  };

  return (
    <form
      className="text-center flex flex-col w-fit xl:w-1/2 mr-4"
      onSubmit={handleSubmit}
    >
      <div className="flex flex-col xl:flex-row justify-between">
        <label className="flex flex-col text-center">
          Début
          <input
            type="date"
            value={donnee.debut}
            className="text-xl 3xl:text-3xl border-2 border-bleuCielSTB hover:border-bleuSTB rounded-xl py-2 px-4 text-center mt-4 font-sans m-4"
            onChange={(e) =>
              setDonnee({
                ...donnee,
                debut: moment(e.target.value).format("YYYY-MM-DD"),
              })
            }
          />
        </label>

        <label className="flex flex-col text-center">
          Fin
          <input
            type="date"
            value={donnee.fin}
            className="text-xl 3xl:text-3xl border-2 border-bleuCielSTB hover:border-bleuSTB rounded-xl py-2 px-4 text-center mt-4 font-sans m-4"
            onChange={(e) =>
              setDonnee({
                ...donnee,
                fin: moment(e.target.value).format("YYYY-MM-DD"),
              })
            }
          />
        </label>
      </div>

      <label className="flex flex-col text-center">
        Périodicité
        <select
          value={donnee.granularity}
          onChange={handleGranularityChange}
          className="text-xl 3xl:text-3xl border-2 border-bleuCielSTB hover:border-bleuSTB rounded-xl py-2 px-4 text-center mt-4 font-sans m-4"
        >
          {availableGranularities.map((g) => (
            <option key={g} value={g}>
              {granularities[g]}
            </option>
          ))}
        </select>
      </label>

      <button
        type="submit"
        disabled={loading}
        className={`
          bg-bleuSTB text-white text-xl 3xl:text-3xl rounded-3xl px-6 py-4 mt-4
          w-[80%] ml-auto mr-auto flex items-center justify-center gap-3
          ${loading ? "opacity-60 cursor-not-allowed" : "hover:bg-marronSTB"}
        `}
      >
        {loading ? (
          <>
            <FaSpinner className="animate-spin" />
            Chargement...
          </>
        ) : (
          "Rechercher"
        )}
      </button>
    </form>
  );
}